// extracted by mini-css-extract-plugin
module.exports = {"modalRoot":"Popover_modalRoot__g_DY6","root":"Popover_root__jyiAX"};